module.exports = __webpack_public_path__ + "media/img/corporate/job_ad-3170f52bc5ddc836abe40f08bfd1ab11.png";